module.exports = __webpack_public_path__ + "img/stock5.a6a105df.png";